import {
    renderTimeLine,
    renderTimeRect,
    RenderTimeLineFunction,
    RenderTimeRectFunction,
} from './timeline';
import { TimePointer, TimePointerState } from './TimePointer';
import { applyPointer } from './timepoint';
import { PubSubContext } from '@instinet-analytics/core-lib';
import { doNothing } from '../../general';

export interface TimePointerContext extends PubSubContext<TimePointerState> {
    renderTimeLine: RenderTimeLineFunction;
    renderTimeRect: RenderTimeRectFunction;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    applyPointer: (node: any, isDomainValid: boolean, xScale: any) => void;
    getLatest: () => TimePointerState | undefined;
}

export const buildTimePointerContext: (
    showTimeLine: boolean
) => TimePointerContext = (showTimeLine) => {
    const timePointer = new TimePointer();
    return {
        renderTimeLine: showTimeLine ? renderTimeLine(timePointer) : doNothing,
        renderTimeRect: showTimeLine ? renderTimeRect(timePointer) : doNothing,
        publish: timePointer.publish.bind(timePointer),
        applyPointer: applyPointer(timePointer),
        subscribe: timePointer.subscribe.bind(timePointer),
        unsubscribeAll: timePointer.unsubscribeAll.bind(timePointer),
        unsubscribeAllWithPrefix:
            timePointer.unsubscribeAllWithPrefix.bind(timePointer),
        getLatest: () => timePointer.context,
    };
};
